import flatpickr from 'flatpickr';
import {German as flatpickrLocaleDe} from 'flatpickr/dist/l10n/de';

const lang = window.document.documentElement.lang;
if (lang === 'de') {
	flatpickr.localize(flatpickrLocaleDe);
}
